<div class="modal-header">
    <h4 class="modal-title" id="modal-title">{{dialog.title| translate}}</h4>
</div>
<div class="modal-body">
    {{dialog.message | translate}}
</div>
<div class="modal-footer justify-content">
	<div *ngFor="let b of rightBtns" class="flex-start">
		<ng-container *ngTemplateOutlet="btnTemplate; context: {b : b}"></ng-container>
	</div>
    <div *ngFor="let b of leftBtns" class="flex-end">
		<ng-container *ngTemplateOutlet="btnTemplate; context: {b : b}"></ng-container>
	</div>
</div>
<ng-template #btnTemplate let-b="b">
	<button [rlFocusMe]="b.focus" type="button" class="btn btn-default" [ngClass]="{ 'btn-primary' : b.main}" [id]="b.label" (click)="clickBtn(b)" [rlAria]="b.label | translate" [rlTabIndex]>{{b.label | translate}}</button>
</ng-template>